import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';

// const API_BASE =
//   process.env.REACT_APP_API_BASE_URL ||
//   process.env.REACT_APP_API_URL ||
//   'https://restroai.in/api';

const API_BASE =
  process.env.REACT_APP_API_BASE_URL ||
  process.env.REACT_APP_API_URL ||
  'https://restro-backend-vercel.vercel.app/api';

export default function LitePublicBillPage() {
  const { token } = useParams();
  const [state, setState] = useState({ status: 'loading' });
  const [data, setData] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const res = await fetch(`${API_BASE}/restro-lite/shared-bills/${encodeURIComponent(token)}`);
        const json = await res.json().catch(() => ({}));
        if (cancelled) return;
        if (!res.ok) {
          setState({
            status: 'error',
            message: json.message || (res.status === 410 ? 'This link has expired.' : 'Bill not found.'),
          });
          return;
        }
        setData(json);
        setState({ status: 'ready' });
      } catch {
        if (!cancelled) {
          setState({ status: 'error', message: 'Could not load bill. Check your internet connection.' });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [token]);

  if (state.status === 'loading') {
    return (
      <div className="min-h-screen bg-stone-100 flex items-center justify-center p-6">
        <p className="text-stone-600">Loading bill…</p>
      </div>
    );
  }

  if (state.status === 'error') {
    return (
      <div className="min-h-screen bg-stone-100 flex flex-col items-center justify-center p-6 text-center">
        <p className="text-stone-800 font-semibold text-lg mb-2">Bill unavailable</p>
        <p className="text-stone-600 max-w-md mb-6">{state.message}</p>
        <Link to="/pocketbillingai" className="text-indigo-600 font-medium hover:underline">
          PocketBillingAI →
        </Link>
      </div>
    );
  }

  const expires = data.expiresAt ? new Date(data.expiresAt).toLocaleDateString('en-IN') : '';

  return (
    <div className="min-h-screen bg-stone-200 py-6 px-3">
      <div className="max-w-md mx-auto mb-4 text-center">
        <p className="text-xs font-semibold uppercase tracking-widest text-indigo-700">PocketBillingAI</p>
        {data.shopName ? (
          <h1 className="text-lg font-bold text-stone-900 mt-1">{data.shopName}</h1>
        ) : null}
        {data.billNumber ? (
          <p className="text-sm text-stone-600 mt-1">{data.billNumber}</p>
        ) : null}
        {expires ? (
          <p className="text-xs text-stone-500 mt-2">Link valid until {expires}</p>
        ) : null}
      </div>
      <div
        className="max-w-md mx-auto bg-white shadow-lg rounded-lg overflow-hidden"
        dangerouslySetInnerHTML={{ __html: data.billHtml }}
      />
      <p className="text-center text-xs text-stone-500 mt-6 max-w-md mx-auto">
        Powered by{' '}
        <a href="https://restroai.in/pocketbillingai" className="text-indigo-600 hover:underline">
          PocketBillingAI
        </a>
      </p>
    </div>
  );
}
